import { RiskLevel } from '@models/assessment';

import { Gender } from 'generated/types';

import type { ReferenceRange } from './types';

const referenceRange: ReferenceRange<RiskLevel> = new Map([
  [
    Gender.unknown,
    new Map([
      [RiskLevel.Low, [{ lower: 0, upper: 24 }]],
      [RiskLevel.Medium, [{ lower: 24, upper: 31.6 }]],
      [RiskLevel.High, [{ lower: 31.6, upper: 200 }]],
    ]),
  ],
]);

export default referenceRange;
